// The classic viewer's two entry points: a demo, or a match opened by uuid
const component = () => import('./V5DemoViewerPage.vue');

export default [
  { path: '/v5/demos/:id/review', name: 'V5_demoviewer', component },
  { path: '/v5/matches/:uuid/review', name: 'V5_demoviewer_match', component },
];
